import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";

import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";
import { IResetPassword } from "../interfaces/iresetpassword";
import { IPasswordResetRequest } from "../interfaces/ipasswordresetrequest";

/**
 * @WhatItDoes A service to get the regions data.
 *
 * @HowToUseIt Inject the service
 */
@Injectable()
export class ResetPasswordService extends BaseService {
    constructor(http: HttpClient, authService: AuthService, toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    /**
     * Resets password for the user
     * @param passwordReset Reset password model
     */
    reset(passwordReset: IResetPassword): Observable<any> {
        return super.post("/api/resetpassword", passwordReset);
    }

    /**
     * Sends a password reset request which generates the token email for the user
     * @param email of the person requesting the reset
     */
    resetPasswordRequest(passwordResetRequest: IPasswordResetRequest): Observable<boolean> {
        return super.post("/api/PasswordResetRequest", passwordResetRequest);
    }
}